export const ADD_SUSCRIPCION = `
mutation addSuscripcion($input: InputAddSuscripcion!){
    addSuscripcion(input: $input){
        correo
        suscripcionID
    }
}`;